import React from "react";

function ContactUs() {
  return (
    <section className="contact-section">
      <h2>Let's Get in Touch</h2>
    <p> Whether you need a quick line up or full service, we’ve got your back.
    Call our reservations team at (408) 320-2753 or simply hit the button below to book a reservation.
      </p>
      <div className="contact-buttons">
        <a
          href="https://shops.getsquire.com/book/evergreen-barbershop-san-jose/barber"
          target="_blank"
          rel="noopener noreferrer"
        >
          Book Now
        </a>
      </div>
    </section>
  );
}

export default ContactUs;
